import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { InstituteTypeService } from '../shared/service/institute-type.service';
import { MessageComponent } from '../shared/component/message/message.component';
import { InstituteTypeModel } from '../shared/model/institute-type.model';
import { ReturnMessageModel } from '../shared/model/return-message.model';

@Component({
  selector: 'app-institute-type',
  templateUrl: './institute-type.component.html',
  styleUrls: ['./institute-type.component.css']
})
export class InstituteTypeComponent implements OnInit {
  
  @ViewChild(MessageComponent) message: MessageComponent;

  lastEvent: any;
  totalRecords: number;
  instituteTypes: InstituteTypeModel[] = [];
  instituteType: InstituteTypeModel = new InstituteTypeModel();
  constructor(
    private instituteTypeService: InstituteTypeService,
    private translateService: TranslateService,
    ) { }

  ngOnInit() {
  }

  lazy(e){
    this.lastEvent = e;
    this.instituteTypeService.getPaginated(e.first, e.rows).subscribe(instituteTypes => {
      this.instituteTypes = instituteTypes['rows'] as InstituteTypeModel[];
      this.totalRecords = instituteTypes['count'];
    });
  }

  onSelect(e) {
    this.instituteType = e.data as InstituteTypeModel;
  }

  onSave() {
    this.instituteTypeService.save(this.instituteType).subscribe((r: ReturnMessageModel) => {
      if (r.error){
        return this.message.error(r.message);
      } 
      this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onDelete() {
    this.instituteTypeService.delete(this.instituteType.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) { 
        return this.message.error(this.translate(r.message));
      };
      this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onNew() {
    this.instituteType = new InstituteTypeModel();
  }

  validate() {
    return InstituteTypeModel.validate(this.instituteType);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
  tUpper = (key) => this.translate(key).toString().toUpperCase();
  tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/institute-type/institute-type.component.ts